<ng-content select="ion-button"></ng-content>
<div class="line"></div>

<ng-content #offScreen select="[off-screen]"></ng-content>
